<template>
  <portfolio-page
      art-board-image="/img/cover-02.png"
      art-board-url="https://philsanders.me"
      page-title="Graphic Design"
  >
    <template v-slot:info-content>
      <h3 class="max-w-3xl mx-auto text-balance text-3xl font-semibold tracking-tight text-gray-700 mb-14">
        Company Logos
      </h3>

      <p class="text-xl text-gray-700 max-w-3xl mx-auto mb-14">
        coming soon...
      </p>

      <h3 class="max-w-3xl mx-auto text-balance text-3xl font-semibold tracking-tight text-gray-700 mb-14">
        Print Media
      </h3>

      <p class="text-xl text-gray-700 max-w-3xl mx-auto mb-14">
        coming soon...
      </p>
    </template>
    <template v-slot:level-up-content>
      <ul class="list-image-starG list-inside">
        <li class="leading-10">Adobe Photoshop</li>
        <li class="leading-10">Adobe Illustrator</li>
        <li class="leading-10">Print Mediums</li>
      </ul>
    </template>
  </portfolio-page>
</template>

<script>
import PortfolioPage from "@/components/PortfolioContainer.vue";

export default {
  components: {
    PortfolioPage,
  }
}
</script>
